<script setup>
import { Link } from '@inertiajs/vue3'
import logo from '@/../images/logo.jpg'

const footerLinks = [
  { name: 'About',      href: '/' },
  { name: 'Programs',   href: '/' },
  { name: 'Admissions', href: '/' },
  { name: 'Contact',    href: '/' },
]
</script>

<template>
  <footer class="bg-primary text-white pt-16 pb-8">
    <div class="container mx-auto px-6">
      <div class="grid md:grid-cols-4 gap-12 mb-12">

        <!-- Brand -->
        <div class="md:col-span-2">
          <Link href="/" class="flex items-center gap-3 mb-5">
            <div class="w-11 h-11 bg-white rounded-lg flex items-center justify-center shrink-0">
              <img :src="logo" class="w-9 h-9 rounded object-cover" />
            </div>
            <div>
              <h1 class="text-lg font-bold leading-tight">Bn Mas'ud College</h1>
              <p class="text-xs text-white/60">for Tahfiz and Islamic Studies</p>
            </div>
          </Link>
          <p class="text-white/70 max-w-sm leading-relaxed">
            Excellence in Qur'anic Memorization & Islamic Education since 2012.
          </p>
        </div>

        <!-- Quick Links -->
        <div>
          <h3 class="text-sm font-semibold uppercase tracking-wider mb-4 text-white/80">Quick Links</h3>
          <ul class="space-y-2.5">
            <li v-for="link in footerLinks" :key="link.name">
              <Link :href="link.href" class="text-white/60 hover:text-white text-sm transition">
                {{ link.name }}
              </Link>
            </li>
          </ul>
        </div>

        <!-- Contact -->
        <div>
          <h3 class="text-sm font-semibold uppercase tracking-wider mb-4 text-white/80">Contact</h3>
          <ul class="space-y-2.5 text-white/60 text-sm">
            <li>Saleh Manga Primary School, Gwallaga Bauchi</li>
            <li>
              <a href="mailto:info@bnmasudcollege.com.ng" class="hover:text-white transition">
                info@bnmasudcollege.com.ng
              </a>
            </li>
            <li>
              <a href="tel:+2347031545880" class="hover:text-white transition">
                +234 703 154 5880
              </a>
            </li>
            <li class="flex gap-4 pt-1">
              <a href="https://facebook.com/BnMasudCollege" target="_blank" class="hover:text-white transition" aria-label="Facebook">
                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M22.675 0h-21.35C.597 0 0 .592 0 1.323v21.354C0 23.408.597 24 1.325 24H12.82v-9.294H9.692V11.01h3.128V8.413c0-3.1 1.893-4.788 4.658-4.788 1.325 0 2.463.098 2.794.142v3.24l-1.918.001c-1.504 0-1.794.715-1.794 1.763v2.31h3.587l-.467 3.696h-3.12V24h6.116C23.403 24 24 23.408 24 22.677V1.323C24 .592 23.403 0 22.675 0z"/>
                </svg>
              </a>
              <a href="https://twitter.com/BnMasudCollege" target="_blank" class="hover:text-white transition" aria-label="Twitter">
                <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.954 4.569c-.885.392-1.83.656-2.825.775a4.932 4.932 0 0 0 2.163-2.723 9.865 9.865 0 0 1-3.127 1.196 4.916 4.916 0 0 0-8.384 4.482A13.944 13.944 0 0 1 1.671 3.149a4.822 4.822 0 0 0-.666 2.475 4.917 4.917 0 0 0 2.188 4.096 4.903 4.903 0 0 1-2.228-.616v.06a4.918 4.918 0 0 0 3.946 4.827 4.996 4.996 0 0 1-2.224.084 4.922 4.922 0 0 0 4.604 3.417A9.867 9.867 0 0 1 .96 19.54a13.93 13.93 0 0 0 7.548 2.212c9.142 0 14.307-7.721 13.995-14.646a9.936 9.936 0 0 0 2.411-2.534z"/>
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="border-t border-white/10 pt-6 text-center text-white/40 text-sm">
        © {{ new Date().getFullYear() }} Bn Mas'ud College. All rights reserved.
      </div>
    </div>
  </footer>
</template>